import { render } from "./Thirdstoreopen.vue?vue&type=template&id=0b56d1cd&scoped=true"
import script from "./Thirdstoreopen.vue?vue&type=script&lang=js"
export * from "./Thirdstoreopen.vue?vue&type=script&lang=js"

import "./Thirdstoreopen.vue?vue&type=style&index=0&id=0b56d1cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b56d1cd"]])

export default __exports__